import { render, staticRenderFns } from "./ColorMeaning.vue?vue&type=template&id=876533c0"
import script from "./ColorMeaning.vue?vue&type=script&lang=js"
export * from "./ColorMeaning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports